import { CATEGORY_TYPE } from 'models/documents.model';

export const getInitialValues = (type: CATEGORY_TYPE) => {
  switch (type) {
    case CATEGORY_TYPE.CERTIFICATE:
      return { percentRecycled: 0 };
    case CATEGORY_TYPE.BATTERY_CELLS:
      return { title: 'Tech Specifications' };
    case CATEGORY_TYPE.BATTERY_PACKS:
      return { title: 'User Manual' };
    case CATEGORY_TYPE.BATTERY_TECH_REVIEW:
      return { title: 'Batteries tech review' };
    case CATEGORY_TYPE.BATTERY_PACKS_REPAIR:
      return { title: 'Battery Packs Repair' };
    case CATEGORY_TYPE.BATTERY_REPURPOSE:
      return { title: 'Battery Repurpose' };
    case CATEGORY_TYPE.BATTERY_PACKS_RECYCLING:
      return { title: 'Battery Packs Recycling' };
    case CATEGORY_TYPE.BATTERY_WASTE:
      return { title: 'Battery Waste' };
    default:
      return {};
  }
};
